import React from 'react';
import PayoutFlow from '../../Payout/Flow/PayoutFlow';
import { Box, Typography, CircularProgress } from '@mui/material';
import { usePayoutAllowedCities } from '../../../hooks/usePayoutAllowedCities';

const DriverPayout = () => {
    const { allowedCitiesLoading, isCityAllowed, allowedCityNamesMsg } = usePayoutAllowedCities();

    if (allowedCitiesLoading) {
        return (
            <Box sx={{ padding: '20px 10px', mt: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        );
    }
    return (
        <>
            {
                isCityAllowed ? (
                    <Box sx={{ padding: '20px 10px', mt: 10 }}>
                        <PayoutFlow />
                    </Box>
                ) : (
                    <Box sx={{ padding: '20px 10px', mt: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography variant="h6" color="text.secondary">This Service is only available for {allowedCityNamesMsg}</Typography>
                    </Box>
                )
            }
        </>
    );
};

export default DriverPayout;
